import { create } from 'zustand';
import { ExternalPatient } from '../contexts/PatientContext';

interface IStore {
  patient: ExternalPatient | undefined;
  setPatient: (props: ExternalPatient) => void;
}

export const usePatientExternal = create<IStore>(set => ({
  patient: undefined,
  setPatient: patient =>
    set({
      patient
    })
}));
